/* eslint-disable import/no-named-as-default */
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { compose } from 'redux';
import HomePage from './features/home/HomePage';
import NoAccessPage from './components/noaccess/NoAccessPage';
import RegionListPage from './features/regions/list/RegionListPage';
import Se360UsersPage from './features/se360users/Se360UsersPage';
import ProductListPage from './features/products/list/ProductListPage';
import ImageEditorsPage from './features/imageeditors/ImageEditorsPage';
import { withAuth } from './components/common/AuthenticatedComponent';
import * as Features from './shared/Features';
import ProductTypesPage from './features/producttypes/ProductTypesPage';
import PhotographersPage from './features/photographers/PhotographersPage';
import PlanFirmsPage from './features/planfirms/PlanFirmsPage';
import ProductGroupsPage from './features/productGroups/ProductGroupsPage';
import BrokerTreePage from './features/brokers/tree/BrokerTreePage';
import AgreementsPage from './features/agreements/AgreementsPage';
import PlanEditorsPage from './features/planeditors/PlanEditorsPage';
import LegalEntitiesPage from './features/legalentities/LegalEntitiesPage';
import PlanOrderList from './features/orders/list/PlanOrderList';
import InvoicePage from './features/invoice/InvoicePage';
import InvoiceHistoryPage from './features/invoice/InvoiceHistoryPage';
import PhotographerInvoicePage from './features/invoice/photographer/PhotographerInvoicePage';
import ImportExportPage from './features/invoice/ImportExportPage';
import ViewOrderPage from './features/orders/view/ViewOrderPage';
import RedirectOrderPage from './features/orders/view/RedirectOrderPage';
import PhotographerUploadPage from './features/photographerupload/PhotographerUploadPage';
import CreateOrderPageDelegate from './features/orders/createOrder/CreateOrderPageDelegate';
import BrokerAgentAutoCreatedInfoPage from './features/orders/BrokerAgentAutoCreatedInfoPage';
import CloneOrderPage from './features/orders/CloneOrderPage';
import PlanTemplatesPage from './features/plantemplates/PlanTemplatesPage';
import TemplateListPage from './features/templates/TemplateListPage';
import PhotographerCalendar from './features/photographerPersonalCalendar/PhotographerPersonalCalendar';
import StylingUserCalendar from './features/stylingUserPersonalCalendars/StylingUserPersonalCalendar';
import CommonTextsPage from './features/commontexts/CommonTextsPage';
import CustomerPhotographerBookingDelegate from './features/photographerBooking/se360/CustomerPhotographerBookingDelegate';
import ScandphotosPhotographerBooking from './features/photographerBooking/scandphotos/ScandphotosPhotographerBookingPage';
import ProfilePage from './features/profile/ProfilePage';
import pageNotFound from './features/pageNotFound/404';
import PhotographerCalendarPage from './features/photographerCalendars/PhotographerCalendarsPage';
import StylingCalendarsPage from './features/stylingCalendars/StylingCalendarsPage';
import PhotographerAgreementPage from './features/photographerAgreement/AgreementProductsPage';
import BrokerListPage from './features/brokers/list/BrokerListPage';
import ImageEditorFirmsPage from './features/imageeditorfirms/ImageEditorFirmsPage';
import StylingFirmsPage from './features/stylingfirms/StylingFirmsPage';
import StylingUserPage from './features/stylingusers/StylingUserPage';
import EditedPhotoOrderList from './features/photoorderlists/EditedPhotoOrderList';
import UneditedPhotoOrderList from './features/photoorderlists/UneditedPhotoOrderList';
import UneditedFuturePhotoOrderList from './features/photoorderlists/UneditedFuturePhotoOrderList';
import PlanEditorOrdersList from './features/planeditorOrders/PlanEditorOrdersList';
import ScandphotosCreateOrdersPage from './features/orders/scandphotos/ScandphotosCreateOrdersPage';
import ViewOrderCollectionPage from './features/orders/view/ordercollection/ViewOrderCollectionPage';
import Statistics from './features/statistics/StatisticsPage';
import PhotographerOverview from './features/photographerOverview/PhotographerOverview';
import ImageGallery from './features/deliveredimagegallery/DeliveredImagesGalleryPage';
import PhotoOrders from './features/orders/listphotoorders/PhotoOrdersPage';
import UnBookedOrders from './features/orders/listunbookedorders/UnBookedOrdersPageDelegate';
import FilmOrders from './features/orders/listfilmorders/FilmOrdersPage';
import AdvanceSearch from './features/orders/list/advanceSearchList/AdvanceSearchPage';
import InvoiceJournalsPage from './features/invoiceJournals/InvoiceJournalsPage';
import PaymentJournalsPage from './features/paymentJournals/PaymentJournalsPage';
import InvoiceProductTypeListPage from './features/invoiceProductType/invoiceProductTypeListPage';
import ReceivablesPage from './features/receivable/ReceivablesPage';
import ErrorInternationalAtomicTimeIsInFuture from './components/errors/ErrorInternationalAtomicTimeIsInFuture';
import { withFeatureCheck } from './components/common/CheckFeatures';
import BrokerAgentsOrderPageDelegate from './features/orders/list/brokerAgentOrderList/BrokerAgentsOrderPageDelegate';
import FavoriteImagesPage from './features/favoriteImages/FavoriteImagesPage';
import CopywritersPage from './features/copywriters/CopywritersPage';
import DuskPhotographerBooking from './features/photographerBooking/se360/SE360DuskPhotographerBooking';
import ZentuvoInvoicingPage from './features/zentuvoInvoicing/ZentuvoInvoicingPage';
import DigitalStylingOrderListPage from './features/orders/list/digitalStyling/entry/view/DigitalStylingOrderListPage';
import BrokerSystemNoAccessPage from './components/noaccess/BrokerSystemNoAccessPage';
import NewsEditor from './features/news/NewsEditorComponent';
import UserNotFoundAccessPage from './components/userNotFound/UserNotFoundAccessPage';
import FeatureFlagsPage from './features/featureFlags/FeatureFlagsPage';
import EditingStylesPage from './features/editingStyles/EditingStylesPage';
import CustomerAgreementsPage from './features/customerAgreements/CustomerAgreementsPage';
import CustomerCalendarWhenEnabled from './features/customerCalendar/entry/view/CustomerCalendarWhenEnabled';

const withAuthAndFeatureCheck = compose(withAuth, withFeatureCheck);

const HomePageComponent = withAuthAndFeatureCheck(HomePage);
const Se360UsersPageComponent = withAuthAndFeatureCheck(Se360UsersPage);
const ImageEditorsPageComponent = withAuthAndFeatureCheck(ImageEditorsPage);
const ProductListPageComponent = withAuthAndFeatureCheck(ProductListPage);
const PlanFirmsPageComponent = withAuthAndFeatureCheck(PlanFirmsPage, Features.ListPlanFirms);
const ProductTypesPageComponent = withAuthAndFeatureCheck(
    ProductTypesPage,
    Features.ListProductTypes
);
const ProductGroupsPageComponent = withAuthAndFeatureCheck(ProductGroupsPage);
const RegionListPageComponent = withAuthAndFeatureCheck(RegionListPage);
const PhotographersPageComponent = withAuthAndFeatureCheck(PhotographersPage);
const BrokerTreePageComponent = withAuthAndFeatureCheck(BrokerTreePage);
const AgreementsPageComponent = withAuthAndFeatureCheck(AgreementsPage);
const PlanEditorsPageComponent = withAuthAndFeatureCheck(PlanEditorsPage);
const LegalEntitiesPageComponent = withAuthAndFeatureCheck(LegalEntitiesPage);
const PhotographerUploadPageComponent = withAuthAndFeatureCheck(PhotographerUploadPage);
const CreateOrderPageComponent = withAuthAndFeatureCheck(CreateOrderPageDelegate);
const CloneOrderPageComponent = withAuthAndFeatureCheck(CloneOrderPage);
const OrdersPageComponent = withAuthAndFeatureCheck(BrokerAgentsOrderPageDelegate);
const ViewOrderPageComponent = withAuthAndFeatureCheck(ViewOrderPage);
const RedirectToOrderComponent = withAuthAndFeatureCheck(RedirectOrderPage);

const PlanOrderListComponent = withAuthAndFeatureCheck(PlanOrderList);
const PhotoOrdersComponent = withAuthAndFeatureCheck(PhotoOrders);
const UnBookedOrdersComponent = withAuthAndFeatureCheck(UnBookedOrders);
const FilmOrdersComponent = withAuthAndFeatureCheck(FilmOrders);
const AdvanceSearchComponent = withAuthAndFeatureCheck(AdvanceSearch);
const PlanTemplatesPageComponent = withAuthAndFeatureCheck(PlanTemplatesPage);
const TemplateListPageComponent = withAuthAndFeatureCheck(TemplateListPage);
const PhotographerCalendarComponent = withAuthAndFeatureCheck(PhotographerCalendar);
const CommonTextsPageComponent = withAuthAndFeatureCheck(CommonTextsPage);
const SE360PhotographerBookingComponent = withAuthAndFeatureCheck(
    CustomerPhotographerBookingDelegate
);
const SE360DuskPhotographerBookingComponent = withAuthAndFeatureCheck(DuskPhotographerBooking);
const ScandphotosPhotographerBookingComponent = withAuthAndFeatureCheck(
    ScandphotosPhotographerBooking
);
const ProfilePageComponent = withAuthAndFeatureCheck(ProfilePage);
const BrokerListPageComponent = withAuth(BrokerListPage);
const PhotographerCalendarPageComponent = withAuth(PhotographerCalendarPage);
const StylingCalendarPageComponent = withAuth(StylingCalendarsPage);
const PhotographerAgreementPageComponent = withAuthAndFeatureCheck(PhotographerAgreementPage);
const ImageEditorFirmsPageComponent = withAuthAndFeatureCheck(ImageEditorFirmsPage);

const StylingFirmsPageComponent = withAuthAndFeatureCheck(StylingFirmsPage);
const StylingUsersPageComponent = withAuthAndFeatureCheck(StylingUserPage);
const StylingUserCalendarComponent = withAuthAndFeatureCheck(StylingUserCalendar);

const Copywriters = withAuthAndFeatureCheck(CopywritersPage);

const EditedPhotoOrderListComponent = withAuthAndFeatureCheck(EditedPhotoOrderList);
const InvoicePageComponent = withAuthAndFeatureCheck(InvoicePage);
const InvoiceHistoryPageComponent = withAuthAndFeatureCheck(InvoiceHistoryPage);
const InvoiceProductTypeListPageComponent = withAuthAndFeatureCheck(InvoiceProductTypeListPage);
const InvoiceJournalsPageComponent = withAuthAndFeatureCheck(InvoiceJournalsPage);
const PaymentJournalsPageComponent = withAuthAndFeatureCheck(PaymentJournalsPage);
const PhotographerInvoicePageComponent = withAuthAndFeatureCheck(PhotographerInvoicePage);
const ImportExportPageComponent = withAuthAndFeatureCheck(ImportExportPage);
const ReceivablesPageComponent = withAuthAndFeatureCheck(ReceivablesPage);
const UneditedPhotoOrderListComponent = withAuthAndFeatureCheck(UneditedPhotoOrderList);
const UneditedFuturePhotoOrderListComponent = withAuthAndFeatureCheck(UneditedFuturePhotoOrderList);
const PlanEditorOrdersListComponent = withAuthAndFeatureCheck(PlanEditorOrdersList);
const ViewOrderCollectionPageComponent = withAuthAndFeatureCheck(ViewOrderCollectionPage);
const StatisticsComponent = withAuthAndFeatureCheck(Statistics);
const PhotographerOverviewComponent = withAuthAndFeatureCheck(PhotographerOverview);
const ScandphotosCreateOrdersPageComponent = withAuthAndFeatureCheck(ScandphotosCreateOrdersPage);

let DigitalStylingOrderListComponent = withAuthAndFeatureCheck(DigitalStylingOrderListPage);

const FavoriteImagesComponent = withAuthAndFeatureCheck(FavoriteImagesPage);

const CallbackComponent = withAuth(() => null);

const ExportToProcountorComponent = withAuthAndFeatureCheck(ZentuvoInvoicingPage);
const NewsEditorComponent = withAuthAndFeatureCheck(NewsEditor);
const FeatureFlagsPageComponent = withAuthAndFeatureCheck(
    FeatureFlagsPage,
    Features.ManageFeatureFlags
);
const CustomerAgreementsPageComponent = withAuthAndFeatureCheck(CustomerAgreementsPage, [
    Features.CreateCustomerAgreements,
    Features.EditCustomerAgreements
]);
const EditingStylesPageComponent = withAuthAndFeatureCheck(
    EditingStylesPage,
    Features.ManageEditingStyles
);
const CustomerCalendarPageComponent = withAuthAndFeatureCheck(
    CustomerCalendarWhenEnabled,
    Features.ViewCustomerCalendar
);

function Routes() {
    return (
        <Switch>
            <Route path="/" exact component={HomePageComponent} />
            <Route path="/no-access" component={NoAccessPage} />
            <Route path="/no-access-brokersystem" component={BrokerSystemNoAccessPage} />
            <Route path = "/user-not-found" component={UserNotFoundAccessPage} />
            <Route path="/se360users" component={Se360UsersPageComponent} />
            <Route path="/imageeditors" component={ImageEditorsPageComponent} />
            <Route path="/products" component={ProductListPageComponent} />
            <Route path="/planfirms" component={PlanFirmsPageComponent} />
            <Route path="/producttypes" component={ProductTypesPageComponent} />
            <Route path="/productgroups" component={ProductGroupsPageComponent} />
            <Route path="/regions" component={RegionListPageComponent} />
            <Route path="/photographers/:id?" component={PhotographersPageComponent} />
            <Route path="/brokers/:nodeId?" component={BrokerTreePageComponent} />
            <Route path="/agreements" component={AgreementsPageComponent} />
            <Route path="/customer-agreements" component={CustomerAgreementsPageComponent} />
            <Route path="/customer-calendar" component={CustomerCalendarPageComponent} />
            <Route path="/planeditors" component={PlanEditorsPageComponent} />
            <Route path="/legalentities" component={LegalEntitiesPageComponent} />
            <Route path="/photographer-uploads" component={PhotographerUploadPageComponent} />
            <Route path="/orders/registration-info" component={BrokerAgentAutoCreatedInfoPage} />
            <Route path="/orders/new/:orderCollectionId?" component={CreateOrderPageComponent} />
            <Route path="/orders/clone/:orderId" component={CloneOrderPageComponent} />
            <Route exact strict path="/orders" component={OrdersPageComponent} />
            <Route path="/orders/:orderId" component={ViewOrderPageComponent} />

            <Route path="/order/:orderNumber" component={RedirectToOrderComponent} />

            <Route path="/orders-list/plans" component={PlanOrderListComponent} />
            <Route path="/orders-list/photos" component={PhotoOrdersComponent} />
            <Route path="/orders-list/bookings" component={UnBookedOrdersComponent} />
            <Route path="/orders-list/films" component={FilmOrdersComponent} />
            <Route
                path="/orders-list/digital-styling"
                component={DigitalStylingOrderListComponent}
            />
            <Route path="/orders-list/advance" component={AdvanceSearchComponent} />
            <Route path="/plantemplates" component={PlanTemplatesPageComponent} />
            <Route path="/templates" component={TemplateListPageComponent} />
            <Route path="/photographercalendar" component={PhotographerCalendarComponent} />
            <Route path="/stylingcalendar" component={StylingUserCalendarComponent} />
            <Route path="/commontexts" component={CommonTextsPageComponent} />
            <Route
                path="/se360/photographerbooking"
                component={SE360PhotographerBookingComponent}
            />
            <Route
                path="/se360/duskphotographybooking"
                component={SE360DuskPhotographerBookingComponent}
            />
            <Route
                path="/scandphotos/photographerbooking"
                component={ScandphotosPhotographerBookingComponent}
            />
            <Route path="/se360/stylingbooking" component={SE360PhotographerBookingComponent} />
            <Route path="/profile" component={ProfilePageComponent} />
            <Route path="/brokeragents" component={BrokerListPageComponent} />
            <Route path="/calendars" component={PhotographerCalendarPageComponent} />
            <Route path="/stylingcalendars" component={StylingCalendarPageComponent} />
            <Route path="/404" component={pageNotFound} />
            <Route
                path="/errors/iat-is-in-the-in-future"
                component={ErrorInternationalAtomicTimeIsInFuture}
            />
            <Route path="/photographeragreement" component={PhotographerAgreementPageComponent} />
            <Route path="/imageeditorfirms" component={ImageEditorFirmsPageComponent} />
            <Route path="/stylingfirms" component={StylingFirmsPageComponent} />
            <Route path="/stylingusers" component={StylingUsersPageComponent} />
            <Route path="/orders-list/photographer" component={EditedPhotoOrderListComponent} />
            <Route path="/invoice" component={InvoicePageComponent} />
            <Route path="/invoices" component={InvoiceHistoryPageComponent} />
            <Route path="/invoice-product-types" component={InvoiceProductTypeListPageComponent} />
            <Route path="/invoice-journals" component={InvoiceJournalsPageComponent} />
            <Route path="/payment-journals" component={PaymentJournalsPageComponent} />
            <Route path="/photographer-invoice" component={PhotographerInvoicePageComponent} />
            <Route path="/importexport" component={ImportExportPageComponent} />
            <Route path="/receivables" component={ReceivablesPageComponent} />
            <Route path="/unedited-orders" component={UneditedPhotoOrderListComponent} />
            <Route
                path="/unedited-future-orders"
                component={UneditedFuturePhotoOrderListComponent}
            />
            <Route path="/orderlist" component={PlanEditorOrdersListComponent} />
            <Route
                path="/ordercollections/:orderCollectionId"
                component={ViewOrderCollectionPageComponent}
            />
            <Route path="/statistics" component={StatisticsComponent} />
            <Route path="/photographer-overview" component={PhotographerOverviewComponent} />
            <Route
                path="/scandphotos/orders/new/:orderCollectionId?"
                component={ScandphotosCreateOrdersPageComponent}
            />
            <Route path="/favorite-images/:selectedImageId?" component={FavoriteImagesComponent} />

            <Route path="/imagegallery" component={ImageGallery} />
            <Route path="/copywriters" component={Copywriters} />
            <Route path="/callback" component={CallbackComponent} />
            <Route path="/export-to-procountor" component={ExportToProcountorComponent} />
            <Route path="/news-editor" component={NewsEditorComponent} />
            <Route path="/feature-flags" component={FeatureFlagsPageComponent} />
            <Route path="/editing-styles" component={EditingStylesPageComponent} />
            <Route path="*" component={pageNotFound} />
        </Switch>
    );
}

export default Routes;
